
<template>
  <div>
    <a class="ActTwelveFloat" :class="{ 'ON': isShow && uniq_id != 'P75968134'  }"
       :href="NEW_YEAR_ACT"
       target="_blank"
    >


      <i class="icon_close2" @click.stop.prevent="isShow = false"></i>

      <div class="ActTwelveFloatBtn">


              <div class="time-box">
                <span class="h">{{ times.h }}:</span>
                <span class="m">{{ times.m }}:</span>
                <span class="s">{{ times.s }}{{ times.hm }}</span>
              </div>

            <div class="time-q">
               抢>
            </div>

      </div>
    </a>
  </div>
</template>

<script>
import {fnBasic} from "@/fn/_fn";
import {ACTIVE_GUOQING} from "@/constant/_constant/CON_BASIC";
import {fnLocalStorage} from "@/fn";
import {MODEL_GUO_QING_BUOY, MODEL_GUO_QING_FLOAT} from "@/constant/MODELS";
import mixinCountDown from "@/mixins/mixinCountDown";
import {ACT, NEW_YEAR_ACT, PAY_COMPANY_NEW} from "@/constant/_Public/Path";
import {mapState} from "vuex";

export default {
  name: "ActTwelveFloat",
  mixins: [mixinCountDown],
  computed: {
    ...mapState('user', [
      'phone', 'uniq_id', 'personVipState', 'personVipInfo', 'businessVipState', 'businessVipInfo', 'avatar', 'iphone', 'isLogin'
    ]),
  },
  data() {
    return {
      isShow: true,
      ACT,
      PAY_COMPANY_NEW,
      NEW_YEAR_ACT
    }
  },
  mounted() {
    this.initTimer()
  },

  methods: {},
  beforeDestroy() {
    this.clearTimer();
  },
}
</script>

<style lang="scss" scoped>
@keyframes slide {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(20px);
  }
  100% {
    transform: translateY(0);
  }

}

.ActTwelveFloat {
  display: block;
  transition: all 0.5s ease;
  @include BgImage2(318px, 185px, 'act/newYearFloat_251223.png', 1);
  background-size: 318px 185px;
  //@include BgImage2(294px, 322px, 'act/act-float2.png?v=1', 1);
  //background-size: 294px 322px;
  vertical-align: middle;
  cursor: pointer;
  position: fixed;
  right: -999px;
  top: 200px;
  z-index: 88;
  animation: slide 2s ease-in-out infinite;

  &.ON {
    right: 15px;
  }

  .ActTwelveFloatBtn{
    //@include BgImage2(118px, 44px, 'act/ActTwelveFloatBtn.png?v=1', 1);
    background-size: 118px 44px;
    position: absolute;
   bottom: 8px;
    left: 49%;
    transform: translateX(-50%);
  }


  .icon_close2 {
    @include BgImage(20px, 20px, 'pay/act-company/icon_close2.png');
    position: absolute;
    bottom: -32px;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
    box-sizing: border-box;

    &:after{
      content: '';
      display: inline-block;
      width: 40px;
      height: 40px;
      //background: pink;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      //border: 1px solid #000;
    }
  }

  .ActTwelveFloatBtn{
    display: flex;
    align-items: center;
  }

  .time-q{
    font-weight: bold;
    color: rgba(254, 77, 39, 1);
    font-size: 13px;
    text-shadow: 0px 1px 2px rgba(47,0,1,0.3);
    margin-left: 6px;
  }
  .time-box {
    height: 18px;
    box-sizing: border-box;
    //position: absolute;
    left: 51%;
    bottom: 5px;
    //transform: translateX(-50%);
    text-align: center;
    padding-left: 3px;
    white-space: nowrap;
    text-shadow: 0px 1px 2px rgba(47,0,1,0.3);

    span {
      display: inline-block;
      width: 18px;
      height: 18px;
      font-weight: bold;
      color: rgba(254, 77, 39, 1);
      line-height: 18px;
      font-size: 13px;
    }

    .h {
    }

    .m {
    }

    .s {
      width: 27px;
    }


  }

}
</style>

